import {computed, signal} from "@preact/signals-react";

import {GROUPED_BY, KPI_PRICING, KPI_TYPE} from "@constants";

export const kpiType = signal(KPI_TYPE.ACTUAL_PRICE)
export const kpiPrice = signal(KPI_PRICING.ACTUAL)
export const groupedBy = signal(GROUPED_BY.COUNTRY)
export const includeShippingPrice = signal(false)
export const buyBox = signal(false)
export const authorizedSeller = signal(false)
export const splitKpi = signal([GROUPED_BY.RETAILER])
export const vision = signal(GROUPED_BY.COUNTRY)
export const validated = signal([0, 1])
export const normalized = signal([0, 1])

//Computed
export const isGroupedByCountry = computed(() => groupedBy.value === GROUPED_BY.COUNTRY)
export const isGroupedByRetailer = computed(() => groupedBy.value === GROUPED_BY.RETAILER)